import React from "react";
import styles from "./FloatingActionButton.module.css";
import { Phone } from "lucide-react";
import Link from "next/link";

const FloatingActionButton: React.FC = () => {
  return (
    <div className={styles.fabContainer} style={{ minWidth: "60px" }}>
      <div className={styles.fabOptions}>
        <div className={styles.relativeText}>
          <Link href="tel:+27116695005" target="_blank" title="+27116695005">
            <Phone style={{ color: "#fff" }} />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default FloatingActionButton;
